module.exports = __webpack_public_path__ + "img/ring_r_s_null_null@2x.3aa8288b.png";